import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as momenttz from 'moment-timezone';
import { UserSessionService } from './usersession.service';
import { UserSession } from '../models/usersession';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, map } from 'rxjs';
import { jwtDecode } from 'jwt-decode';
import { DataService } from './data.service';
import { ToastrService } from 'ngx-toastr';
import { RoleType } from '../enum/role-type';

//const timezone = require('src/assets/json/timezones.json');
@Injectable({
    providedIn: 'root',
})
export class AuthenticationService {
    isFirstTime: boolean = true;
    vumatelAPIOrderNumber: string = "";
    private baseUrl = environment.apiBaseUrl;
    sessionData = new UserSession();
    timeZones: any[];
    CurrentLoginUserID: number = 0;
    // userids = [ "2177",
    //             "51916823",
    //             "50889115",
    //             "34748852",
    //             "51326888",
    //             "50501890",
    //         "50501929"]
    userProfileStream: string;
    public userImage = new BehaviorSubject<any>({});
    RoleType = RoleType
    constructor(
        private sessionService: UserSessionService,
        private http: HttpClient,
        private dataService: DataService,
        private toastr: ToastrService,
    ) {
        //this.getTimeZones();
    }
    setFirstTime(value: boolean) {
        this.isFirstTime = value;
    }
    getIsFirstTime(): boolean {
        console.log();

        return this.isFirstTime;
    }
    setuserProfileStream(value: string) {
        this.userProfileStream = value;
    }

    getuserProfileStream(): string {
        return this.userProfileStream;
    }

    getuserImage() {
        return this.userImage.asObservable();
    }

    setvumatelAPIOrderNumber(value: string) {
        this.vumatelAPIOrderNumber = value;
    }
    getvumatelAPIOrderNumber(): string {
        return this.vumatelAPIOrderNumber;
    }

    getTimeZones() {
        //this.timeZones = timezone.timeZone;
    }

    getBrowserTimeZone(): string {
        const zoneName = momenttz.tz.guess();
        const temptimezone = momenttz.tz(zoneName).zoneAbbr();
        const filterZone = this.timeZones.find((i) => i.abbr === temptimezone);
        if (filterZone) {
            return filterZone.value;
        }
        return '';
    }
    logOut() {
        this.dataService.clearCache();
        this.sessionService.destroy();
    }

    login(credentials: any) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
        });
        var payload = '';
        if (credentials.microsoftToken) {
            const scope = [null, credentials.isUssd];
            payload = 'grant_type=password' +
                `&username=${encodeURIComponent(credentials.useremail.trim())}` +
                `&scope=${encodeURIComponent(false)}` +
                `&microSoftToken=${encodeURIComponent(credentials.microsoftToken)}`;
        }
        else {
            const scope = [credentials.pin, credentials.isUssd];
            payload = 'grant_type=password' +
                `&username=${encodeURIComponent(credentials.useremail)}` +
                `&password=${encodeURIComponent(credentials.password)}` +
                `&scope=${encodeURIComponent(scope.join(','))}`;
        }
        return this.http
            .post<any>(this.baseUrl + '/api/oauth/token', payload, { headers })
            .pipe(
                map((user) => {
                    if (user && user.access_token) {
                        this.logOut();
                        const decodedToken = jwtDecode(user.access_token);
                        const roletype = decodedToken['user.roletype'];
                        const resellerAccount = decodedToken['user.resellerAccount'];
                        const userID = decodedToken['user.id'];
                        if (resellerAccount == "1") {
                            this.toastr.error('Access denied. Please log in through the customer portal at https://portal.home-connect.co.za/ to continue.');
                            return;
                        }
                        if ((roletype != this.RoleType.ResellerCustomer && roletype != this.RoleType.User && roletype != this.RoleType.VumatelUser)) {
                            // if (this.userids.includes(userID)) {
                            this.sessionData.accessToken = user.access_token;
                            this.sessionData.id = decodedToken['user.id'];
                            this.sessionData.username = decodedToken['user.username'];
                            this.sessionData.firstname = decodedToken['user.firstname'];
                            this.sessionData.lastname = decodedToken['user.lastname'];
                            this.sessionData.emailid = decodedToken['user.emailid'];
                            this.sessionData.title = decodedToken['user.title'];
                            this.sessionData.identificationnumber = decodedToken['user.identificationnumber'];
                            this.sessionData.primarycontactnumber = decodedToken['user.primarycontactnumber'];
                            this.sessionData.landlinenumber = decodedToken['user.landlinenumber'];
                            this.sessionData.mobilenumber = decodedToken['user.mobilenumber'];
                            this.sessionData.roletype = decodedToken['user.roletype'];
                            this.sessionData.roleId = decodedToken['user.roleId'];
                            this.sessionData.userStatusType = decodedToken['user.userStatusType'];
                            this.sessionData.refrenceNumber = decodedToken['user.refrenceNumber'];
                            this.sessionData.gender = decodedToken['user.gender'];
                            this.sessionData.dateofBirth = decodedToken['user.dateofBirth'];
                            this.sessionData.roleDetails = decodedToken['user.roleDetails'];
                            this.sessionData.resellerCode = decodedToken['user.resellerCode'];
                            this.sessionData.salesRepId = decodedToken['user.salesRepId'];
                            this.sessionData.homeLanguage = decodedToken['user.homeLanguage'];
                            this.sessionData.authenticationStatus = decodedToken['user.authenticationStatus'];
                            this.sessionData.expiresUtc = decodedToken['user.expiresUtc'];
                            this.sessionData.isPasswordChangedWithInThreeMonth = decodedToken['user.isPasswordChangedWithInThreeMonth'];

                            this.sessionService.create(this.sessionData);

                        }
                        else {
                            if (roletype)
                                this.toastr.error('Access denied');
                            return
                        }


                    }
                    return user;
                })
            );
    }

    isAuthenticated(): boolean {
        return !!this.sessionData.username && !!this.sessionData.accessToken;
    }

    forgotPassword(userEmail: string, baseURL: string) {
        return this.dataService.getRecord('/api/Login/ForgetPassword/?Email=' + userEmail + '&BaseUrl=' + baseURL);
    }


}
